const BLOG_PAGE_SIZE_VERSION_OPTIONS = [
  { value: 1, label: 'old' },
  { value: 2, label: 'new' },
  { value: 3, label: 'size: A4' },
  { value: 4, label: 'initial' },
];

export default {
  BLOG_PAGE_SIZE_VERSION_OPTIONS,
};
